export default [
    {
        entry: 'Venta',
        shortcut: 'F1',
        route: '/',
    },
    {
        entry: 'Caja',
        shortcut: 'F9',
        children: [
            {
                entry: 'Movimientos',
                route: 'movement',
            },
            {
                entry: 'Arqueo',
                route: 'arqueo',
            },
            {
                entry: 'Rendición',
                route: 'rendicion',
            },
            {
                entry: 'Reportes',
                route: 'reports',
            },
            {
                entry: 'Reporte de Pagos',
                route: 'payment_report',
            },
            {
                entry: 'Correlativos',
                route: 'correlativos',
            },
            {
                entry: 'Facturación Despacho',
                route: 'bill_batch_list',
            },
            {
                entry: 'Transbank',
                route: 'transbank',
            },
            {
                entry: 'Retiro Cheques',
                route: 'retire_bank_check',
            },
            {
                entry: 'Cierre',
                route: 'close',
            },
        ].filter(item => {
            return JSON.parse(process.env.VUE_APP_ENABLE_INTEGRATION_COUNTERS)
                ? true
                : item.entry !== 'Correlativos'
        }),
    },
    {
        entry: 'Pago de Cuentas',
        shortcut: 'F10',
        route: 'customer_payment',
        // children: [
        //     {
        //         entry: 'Pago',
        //         route: 'customer_payment',
        //     },
        //     // {
        //     //     entry: 'Rendición',
        //     //     route: 'customer_payment_verify',
        //     // },
        // ],
    },
    {
        entry: 'Nota de Crédito',
        shortcut: 'F4',
        route: 'nota_credito',
    },
    {
        entry: 'Reimpresión',
        shortcut: 'F6',
        route: '/reimprimir',
    },
    {
        entry: 'Salir',
        shortcut: 'F12',
        route: '/salir',
    },
]
